module.exports = __webpack_public_path__ + "assets/roadsign-7b8673b95624d44ca07625c6b5c74ed8.svg";